module.exports = __webpack_public_path__ + "img/nhjj.85ca92b9.png";